import { useSearchParams } from 'react-router-dom';
import { useFulfiller } from '../FulfillerContext';
import NotFoundState from '../components/common/NotFoundState';

const NotFoundPage = () => {
  const { fulfillerData } = useFulfiller();
  const [searchParams] = useSearchParams();

  const tenantId =
    fulfillerData?.fulfillerLocation.value ?? searchParams.get('tenantId');
  const homePath = tenantId ? `/entitytypes?tenantId=${tenantId}` : '/';

  return (
    <NotFoundState
      message="The page you are looking for does not exist."
      navigationLink={{ to: homePath, text: 'Entity Types' }}
    />
  );
};

export default NotFoundPage;
